import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
	selector: 'app-menu-skeleton-header',
	standalone: true,
	imports: [CommonModule, IonicModule],
	templateUrl: './menu-skeleton-header.component.html',
	styleUrls: ['./menu-skeleton-header.component.scss']
})
export class MenuSkeletonHeaderComponent {

}